import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  /** Controla a exibição do modal. */
  @Input() open = false;
  @Input() title = 'Confirmar envio do produto?';
  @Input() message = '';
  @Input() confirmText = 'Sim';
  @Input() cancelText = 'Não';
  @Input() loading = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    if (this.loading) return;
    this.confirmed.emit();
  }

  onCancel(): void {
    if (this.loading) return;
    this.cancelled.emit();
  }
}
